import SvgIcon, { type SvgIconProps } from "@mui/joy/SvgIcon"

const ArrowDropUp = (props: SvgIconProps) => {
  const Svg = () => (
    <g>
      <path d="M5 10 L10 5 L 15 10 H 5 Z" />
    </g>
  )

  return (
    <SvgIcon {...props} viewBox="0 0 20 16">
      <Svg />
    </SvgIcon>
  )
}

export default ArrowDropUp
